<template>

  <BottomModal v-if="referral" @close="$emit('close')" title="Was this referral scheduled?">
    <div class="flex-grow-1" :key="referral.id">
      <div class="modal-screen">
        <div class="d-flex justify-content-end">
          <span style="font-size:1rem">
            You contacted the following patient. Update the referring office:</span>
          <div v-if="contactedWithNoUpdate.length > 1" class="text-right mt-auto ml-2" style="flex-shrink: 0;">
            <button @click="index--" class="btn btn-xs btn-outline-primary mr-1" style="color:var(--light-color); width: 30px; height: 30px;" :disabled="index==0||isSaving">
              <font-awesome-icon :icon="['far', 'angle-left']" size="lg" />
            </button>
            <button @click="index++" class="btn btn-xs btn-outline-primary ml-1" style="color:var(--light-color); width: 30px; height: 30px;" :disabled="isLast||isSaving">
              <font-awesome-icon :icon="['far', 'angle-right']" size="lg" />
            </button>
          </div>
        </div>
        <div class="modal-referral-details px-3 pb-3 pt-2 my-4 rounded " style="background:#10383C; font-size:.775rem; color:#F8F9F9">
          <div class="row">
            <div class="col text-right">
              <router-link class="btn btn-xs btn-outline-primary px-2 py-1 font-weight-normal" :to="'/referral/' + referral.id" title="View Referral" style="color:var(--light-color)">View referral</router-link>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-4 text-muted">Patient</div>
            <div class="col"><span class="text-nowrap">{{referral.patient_firstname}} {{referral.patient_lastname}}</span></div>
          </div>
          <div class="row mt-2">
            <div class="col-4 text-muted">From</div>
            <div class="col"> <b>{{$helpers.doctor(referral)}}</b><br />
              {{referral.practice.name}} </div>

          </div>
          <div class="row mt-2">
            <div class="col-4 text-muted">Received on</div>
            <div class="col">{{ moment(referral.sent_time).fromNow()}}</div>
          </div>
          <div class="row mt-2">
            <div class="col-4 text-muted">Contacted on</div>
            <div class="col">{{ moment(referral.patient_called_on).fromNow()}}</div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="mr-1 flex-grow-1">
        <a class="btn btn-sm btn-outline-primary btn-block" @click="notInterested" :disabled="isSaving">Not interested</a>
      </div>
      <div class="mr-2 flex-grow-1">
        <a class="btn  btn-sm btn-outline-primary btn-block" @click="unreachable" :disabled="isSaving">Not reachable</a>
      </div>
      <div class="flex-grow-1">
        <a class="btn btn-primary btn-block" @click="markScheduled" :disabled="isSaving">Scheduled</a>
      </div>
    </template>
  </BottomModal>
</template>

<script>
import { ReferralApi } from '@/services'
import { mapState, mapGetters } from 'vuex'
import BottomModal from '@/components/modals/BottomModal.vue'
import moment from 'moment'
export default {
  components: {
    BottomModal,
  },
  data() {
    return {
      isSaving: false,
      index: 0,
    }
  },
  created() {},
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isLoggedIn', 'isOrganization']),
    ...mapState('tour', ['activeTour']),
    ...mapGetters('tour', ['currentTarget']),
    ...mapGetters('referrals', ['all', 'get', 'contactedWithNoUpdate']),
    ...mapState('referrals', ['isLoaded', 'isLoading']),
    referral() {
      return this.contactedWithNoUpdate?.[this.index]
    },
    isLast() {
      return this.contactedWithNoUpdate.length - 1 === this.index
    },
  },
  methods: {
    async markScheduled() {
      this.isSaving = true
      await this.$store.dispatch('referrals/save', {
        ...this.referral,
        is_marked_scheduled: true,
      })
      this.isSaving = false
    },
    async unreachable() {
      this.addNote('Patient unreachable')
      this.snooze(1)
    },
    async notInterested() {
      this.addNote('Patient not interested')
      this.snooze(30)
    },
    async snooze(days) {
      this.isSaving = true
      let r = { ...this.referral }
      r[`snooze_until_${!r.is_incoming ? 'from' : 'to'}_time`] = moment()
        .utc()
        .add(days, 'days')
        .subtract(1, 'minute')
        .toISOString()
      r[`archived_${!r.is_incoming ? 'from' : 'to'}_time`] = moment.utc()

      try {
        await this.$store.dispatch('referrals/save', r)
      } catch (err) {
        this.$exception(err)
      }
      this.isSaving = false
    },
    async addNote(details) {
      this.isSaving = true
      try {
        const data = { details, referral_id: this.referral.id }
        const response = await ReferralApi.saveRelated(
          this.referral.id,
          'history',
          data
        )
      } catch (e) {
        this.$exception(e)
      }
      this.isSaving = false
    },
  },
}
</script>

<style>
</style>